import {useToast} from './use-toast'

/**
 * Display a not implemented toast and cancel event if provided.
 *
 * An optional `message` overrides the default title — used to surface a specific
 * diagnostic (e.g. why a mis-authored CMS entry cannot open) rather than the
 * generic copy. Such messages are developer/editor-facing and intentionally not
 * translated.
 *
 * @example
 *
 * const notImplemented = useNotImplemented()
 * ...
 * <Button onClick={notImplemented} />
 * <Link onClick={notImplemented} />
 * <Button onClick={(e) => notImplemented(e, 'Why this is not wired up')} />
 *
 * @returns {(function(Event?, string?): void)|*}
 */
const useNotImplemented = () => {
    const toast = useToast({status: 'warning'})
    return (e, message) => {
        e?.preventDefault?.()
        toast({title: message || 'Not implemented yet'})
    }
}

export default useNotImplemented
